import React from 'react'
import {setGlobalValue} from '../redux-actions/global-actions'
import {getEnvelopeSvg} from '../battle-optin/get-envelope-svg'
import {
  getSeenModalFromLocalstorage,
  getHasSignedUpFromLocalstorage
} from '../battle-optin/optin-localstorage-operations.js'
import {getRecord} from '../b5-unlocks/getUserBattleRecord'

class HomeOpenOptinModalButton extends React.Component {

  constructor() {
    super();


    //Don't show the button if:
    const isHidingButton = (
      getRecord().totalWins < 2 || //1) Haven't won two battles yet
      getHasSignedUpFromLocalstorage() //2) I've submitted the form before
    );

    //Flash the button if
    const isButtonFlashing = (
      !isHidingButton && //The button is not hiding
      !getSeenModalFromLocalstorage() //We've never seen the form before
    );

    this.state = {
      isHidingButton,
      isButtonFlashing
    };
  }

  handleOpenClick() {

    //Stop the flashing
    this.setState({
      isButtonFlashing: false
    });

    //Open the modal!
    setGlobalValue({
      isHomeEmailModalOpen: true
    })
  }

  render() {

    if (this.state.isHidingButton) {
      return null
    }

    const style = {
      marginTop: "1em",

      border:0,
      outline: 0,
      padding:0,
      display: "block",
      background: "rgba(255,255,255,0)"
    };

    //class based for weird keyframe on an svg's path
    const envelopeClassName = this.state.isButtonFlashing
      ? "EmailOptinEnvelope is-flashing"
      : "EmailOptinEnvelope";

    return (
      <button className="pointer-on-hover" style={style} onClick={this.handleOpenClick.bind(this)}>
        <span>
          {getEnvelopeSvg({
            width: "4em"
          }, envelopeClassName)}
        </span>
      </button>
    );
  }
}

export default HomeOpenOptinModalButton;


// WEBPACK FOOTER //
// ./src/b5-home/HomeOpenOptinModalButton.js